<template>
    <div class="dashboard-wrap">
        <!-- Spinner -->
        <loading :active.sync="loading"></loading>
        <!-- /Spinner -->
        <b-card no-body-header="header" class="dashboard-landing">
            <template #default>
                <div>
                  <b-card-group :key="dashboardData.projectInfo.projectId" deck v-for="dashboardData in allProjectDashboardData">
                        <div class="dashboard-title">{{ dashboardData.projectInfo.name }}</div>
                        <div class="card-deck-area">
                          <b-card class="border card-preview">
                              <div class="card-header custom-header">
                                  Project Overview
                              </div>
                              <ProjectInformationCard :dashboardData="dashboardData"/>
                          </b-card>
                          <b-card class="border card-preview card-graph" @click="addFlexibleGraph('currentStatusGraph')" >
                              <div class="card-header custom-header">
                                전체 MeMO 상황
                              </div>
                              <div class="card-body p-0 container-graph">
                                  <CurrentStatusGraph 
                                                              :dashboardData="dashboardData"
                                                              :isFlexible=false
                                                              filters=''/>
                              </div>
                          </b-card>
  
                          <b-card class="border card-preview card-graph" @click="addFlexibleGraph('changedYesterdayGraph')" >
                              <div class="card-header custom-header">
                                {{ proceedDate }} 진행한 일
                              </div>
                              <div class="card-body p-0 container-graph">
                                  <ChangedYesterdayGraph 
                                                              :dashboardData="dashboardData"
                                                              :isFlexible=false
                                                              filters=''/>
                              </div>
                          </b-card>
                          <b-card class="border card-preview card-graph" @click="addFlexibleGraph('changedTodayGraph')" >
                              <div class="card-header custom-header">
                                오늘 한 일
                              </div>
                              <div class="card-body p-0 container-graph">
                                  <ChangedTodayGraph
                                                              :dashboardData="dashboardData"
                                                              :isFlexible=false
                                                              filters=''/>
                              </div>
                          </b-card>
                        </div>
                    </b-card-group>
                    <!-- <b-card-group class="d-flex flex-column">
                            <ChatterFlexibleDashboardCard2  v-if="showFlexibleGraphConditions['currentStatusGraph']"
                                                        title="프로젝트 현재 상황"
                                                        componentName="CurrentStatusGraph"
                                                        :dashboardData="dashboardData"
                                                        filterType="history" />
                            <ChatterFlexibleDashboardCard2  v-if="showFlexibleGraphConditions['changedYesterdayGraph']"
                                                        title="어제 한 일"
                                                        componentName="ChangedYesterdayGraph"
                                                        :dashboardData="dashboardData"
                                                        filterType="history" />
                            <ChatterFlexibleDashboardCard2  v-if="showFlexibleGraphConditions['changedTodayGraph']"
                                                        title="오늘 한 일"
                                                        componentName="ChangedTodayGraph"
                                                        :dashboardData="dashboardData"
                                                        filterType="history" />                                                                   
                    </b-card-group> -->
                </div>
            </template>
        </b-card>
    </div>
</template>
  <script>
  import Loading from 'vue-loading-overlay';
  import accessToken from "@/services/accessToken";
  import CurrentStatusGraph from './charts2/CurrentStatusGraph.vue';
  import ChangedYesterdayGraph from './charts2/ChangedYesterdayGraph.vue';
  import ChangedTodayGraph from './charts2/ChangedTodayGraph.vue';
  import ProjectInformationCard from './charts2/ProjectInformationCard.vue';
  import ChatterFlexibleDashboardCard2 from '@/components/chatter/project/ChatterFlexibleDashboardCard2.vue';
  import {integer} from "vee-validate/dist/rules.esm";

  export default {
    name:"DashboardRanding",
    props: {
      allProjectDashboardData: {
        type: Object,
      }
    },

    components: { 
        Loading,
        CurrentStatusGraph,
        ChangedYesterdayGraph,
        ChangedTodayGraph,
        ProjectInformationCard,
        ChatterFlexibleDashboardCard2
      },
    computed: {
      integer() {
        return integer
      },

      tableData() {
        const data = [];
        const headerLength = this.table.index.length;
        const rowData = {};

        for (const key in this.table) {
          if (key !== "index") {
            for (let i = 0; i < headerLength; i++) {
              rowData[this.table.index[i]] = this.table[key][i];
            }
            data.push(rowData);
          }
        }
        return data;
      },
      proceedDate(){
        let todayDate = new Date(this.today);
        let yesterdayDate = new Date(todayDate);

        yesterdayDate.setDate(yesterdayDate.getDate() - 1);

        let dayOfWeek = yesterdayDate.getDay();


        if(dayOfWeek === 0) {   // 일요일인 경우
              yesterdayDate.setDate(yesterdayDate.getDate() - 2);

        } else if(dayOfWeek === 6) {    // 토요일인 경우
              yesterdayDate.setDate(yesterdayDate.getDate() - 1);
        }

          this.yesterdayDate = yesterdayDate;

          return yesterdayDate.toISOString().slice(0, 10);

      }
    },
    data() {
      return {
        projectId: '',
        projectName: '',
        loading: false,
        projectInformation: [],
        dashboardImageList :[],
        descriptionList: ["Description", "Start ~ End"],
        columnName: {
          projectId: "ID",
          projectType: "Type",
          name: "Name",
          description: "Description",
          startDate: "Start Date",
          endDate: "End Date"
          },
        yearList: [],
        monthlyInfo : [],
        energyUseSeries: [{
          name: "Working Days",
          data: ""
        }],
        showFlexibleGraphConditions : {
          currentStatusGraph: false,
          changedYesterdayGraph: false,
          changedTodayGraph: false,
        }
      }
    },
    methods: {

      addFlexibleGraph(graphName) {
        this.showFlexibleGraphConditions[graphName] = true;
      },
    }
  }

  </script>
  <style scoped>
  /* import font */
  @import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

  .dashboard-landing > .card-body {
    padding: 0;
  }

  .card-deck {
    margin-bottom: 30px;
  }

  .card-deck:last-child {
    margin-bottom: 0;
  }

  .card-deck .dashboard-title {
    display: inline-block;
    margin-left: 10px;
    color: #000;
    font-family: 'NanumGothic';
    font-size: 20px;
    font-weight: 700;
    line-height: 150%;
  }

  .card-deck .card-deck-area {
    display: flex;
    width: 100%;
    flex-grow: 1;
  }
  </style>